// import { getToken } from './challengeToken';
import { shouldAllowUnauthorized } from './authorizedRoutes';

import { getRawJWT, isJWTValid } from '../lib/jwtHandling';

// Default headers for a fetch request to API
const defaultFetchHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

// Default options for a fetch request to API
const defaultFetchOptions = {
  credentials: 'same-origin',
};

// Converts fetch res to json
export const resToJSON = res => res.json();

// Shorthand to stringify object
export const objToStr = obj => JSON.stringify(obj);

/*
  Fetch middleware function
  - Appends the url to a default api root (API_URL, defined in config)
  - Sets default options and headers
  - Handles the response and resolves as data or error
*/
export const createFetcher = (url, options = {}, headers = {}, defaultHeaders = true) => {
  return new Promise((resolve, reject) => {
    fetch(url, {
      ...defaultFetchOptions,
      headers: {
        mystellarqjwt: getRawJWT(),
        neurojwt: getRawJWT(), // scam solution just before release
        ...(defaultHeaders ? defaultFetchHeaders : null),
        ...headers,
      },
      ...options,
    })
      .then(res => {
        if (!res.ok) return Promise.reject(res);
        if (res.headers.get('content-type') && res.headers.get('content-type').includes('application/json')) {
          return resolve(res.json());
        }
        return resolve(res);
      })
      .catch(err => {
        if (!isJWTValid() && !shouldAllowUnauthorized(window.location.pathname)) {
          const role = window.__ROLE__;
          if (!role || role === 'PATIENT') {
            window.location.replace(LOGIN_URL);
          }

          if (role === 'DOCTOR') {
            window.location.replace(`/api/quitView`);
          }
        }
        return reject(err);
      });
  });
};

export default createFetcher;
